// extracted by mini-css-extract-plugin
export default {"link":"SiderElement_link__zaVEo","fa":"SiderElement_fa__gwD0Q","en":"SiderElement_en__8zCvj","icon":"SiderElement_icon__h7v39","link-text":"SiderElement_link-text__4MOGr"};